import React from "react"
import Accounts from "pages/Accounts/components/accounts";
import AccountOperations from "pages/Accounts/components/accountOperations";
import { checkAnyPermission } from "../../../services/permission";

const Index:React.FC<any> = () => {
    return (
        <>
            {
                checkAnyPermission(['CARILIST']) && <Accounts />
            }
            <AccountOperations />
        </>
    )
}

export default Index;
